import { render, staticRenderFns } from "./InviteOrder.vue?vue&type=template&id=03af4f5a&scoped=true&"
import script from "./InviteOrder.vue?vue&type=script&lang=js&"
export * from "./InviteOrder.vue?vue&type=script&lang=js&"
import style0 from "./InviteOrder.vue?vue&type=style&index=0&id=03af4f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03af4f5a",
  null
  
)

export default component.exports